import * as React from "react";
const SvgScripts = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M16.6654 8.33317V5.6665C16.6654 4.26637 16.6654 3.56631 16.3929 3.03153C16.1532 2.56112 15.7707 2.17867 15.3003 1.93899C14.7656 1.6665 14.0655 1.6665 12.6654 1.6665H7.33203C5.9319 1.6665 5.23183 1.6665 4.69705 1.93899C4.22665 2.17867 3.8442 2.56112 3.60451 3.03153C3.33203 3.56631 3.33203 4.26637 3.33203 5.6665V14.3332C3.33203 15.7333 3.33203 16.4334 3.60451 16.9681C3.8442 17.4386 4.22665 17.821 4.69705 18.0607C5.23183 18.3332 5.9319 18.3332 7.33203 18.3332H9.9987",
	stroke: "currentColor",
	strokeWidth: 1.66667,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.418 9.16683H6.66797M7.5013 12.5002H6.66797M13.3346 5.8335H6.66797",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M17.9225 14.3521C18.8421 13.5703 18.9537 12.191 18.1719 11.2715C17.3901 10.3519 16.0108 10.2403 15.0913 11.0221L11.7613 13.8534C10.8418 14.6353 10.7301 16.0145 11.5119 16.934C12.2938 17.8536 13.673 17.9652 14.5926 17.1834L17.9225 14.3521ZM12.2332 14.4084C11.6201 14.9296 11.5457 15.8491 12.0669 16.4621C12.5882 17.0752 13.5077 17.1496 14.1207 16.6284L15.4881 15.4657L13.6008 13.246L12.2332 14.4084ZM16.0431 14.9939L14.1556 12.7739L15.5632 11.5771C16.1762 11.0559 17.0957 11.1303 17.6169 11.7434C18.1381 12.3564 18.0637 13.2759 17.4506 13.7971L16.0431 14.9939Z",
	fill: "currentColor",
	stroke: "currentColor",
	strokeWidth: .5
}));
export default SvgScripts;
